import Head from 'next/head'
import MainSection from '../src/components/MainSection/MainSection'
import FooterSection from '../src/components/FooterSection/FooterSection'
import HeaderSection from '../src/components/HeaderSection/HeaderSection'



export default function Home({isLightTheme,setLightTheme}) {

  return (
    <>

      {/* METADATA FOR HOME PAGE */}
      <Head lang='en'>
        <title>FUN WITH AI</title>
        <meta name="description" content="Shopify Challenge 2022 Fall" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      {/* HEADER || MAIN || FOOTER */}
      <HeaderSection isLight={isLightTheme} setLightTheme={setLightTheme} />
      <MainSection />
      <FooterSection />

    </>
  )
}
